// extracted by mini-css-extract-plugin
export default {"container":"search_filters_categories-module__container--vxdx_"};